module.exports = __webpack_public_path__ + "static/assets/fecad7da66ad4cdf1942253998bdc4bc.png";